<template>
  <figure :class="$b()">
    <blockquote :class="$b('body')">
      <slot />
    </blockquote>
    <figcaption
      v-if="attribution"
      :class="$b('attribution')"
    >
      <BaseCopy
        size="body-sm"
        tag="span"
      >
        — {{ attribution }}
      </BaseCopy>
    </figcaption>
  </figure>
</template>

<script>
export default {
  name: 'BlockQuote',

  props: {
    attribution: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="postcss">
.BlockQuote {
  @apply pl-sm mb-xs;
}

.BlockQuote__body {
  @apply italic;
}

.BlockQuote__attribution {
  @apply -mt-xs;
}
</style>
